// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"1568":"styles-7369c1d3","1820":"styles-fd3c3502"}[chunkId] + "." + {"1568":"58e90527b3c2ff45935c","1820":"48249cb05d915d73696b"}[chunkId] + ".css";
};